<template>
  <!--START PROCESS-->
  <section class="section bg-light">
    <div class="container">
      <div class="row">
        <div class="col-lg-8 offset-lg-2">
          <h1 class="section-title text-center">Como Funciona</h1>
          <div class="section-title-border margin-t-20"></div>
          <p
            class="section-subtitle text-muted text-center font-secondary padding-t-30"
          >
            Nosso processo de trabalho englob três grandes etapas antes da
            decolagem.
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6 text-center process-left-icon-1">
          <i class="pe-7s-angle-right"></i>
        </div>
        <div class="col-lg-6 text-center process-left-icon-2">
          <i class="pe-7s-angle-right"></i>
        </div>
      </div>
      <div class="row margin-t-50">
        <div class="col-lg-4 plan-line">
          <div class="text-center process-box">
            <i class="pe-7s-pen text-custom"></i>
            <h4 class="padding-t-15">Contenos sua ideia</h4>
            <p class="text-muted">
              Aqui você nos colocará a par de sua necessidade para que possamos
              traçar um plano inicial de ação.
            </p>
          </div>
        </div>
        <div class="col-lg-4 plan-line">
          <div class="text-center process-box">
            <i class="pe-7s-id text-custom"></i>
            <h4 class="padding-t-15">
              Construções de perfil e modelo de negócio
            </h4>
            <p class="text-muted">
              Onde iremos aprimorar seu modelo de negócio, identidade visual,
              estratégia de marketing, etc.
            </p>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="text-center process-box">
            <i class="pe-7s-target text-custom"></i>
            <h4 class="padding-t-15">Entrega contínua de relatório mensal</h4>
            <p class="text-muted">
              Neste processo se encerra o período de consultoria e iniciamos um
              novo ciclo para irmos caminhando juntos uma etapa de cada vez.
            </p>
          </div>
        </div>
        <div class="text-center mx-auto">
          <a
            href="#"
            class="btn btn-custom waves-light waves-effect margin-t-50"
            >Decole <i class="mdi mdi-arrow-right"></i
          ></a>
        </div>
      </div>
    </div>
  </section>
  <!--END PROCESS-->
</template>

<script>
"use strict";
export default {
  name: "StartProcess",
  props: {}
};
</script>
